'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const TimeRecordingPlayIcon = ({ sx, playing = false }) => {
  return (
    <SvgIcon sx={sx} data-testid="TimeRecordingPlayIcon">
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
          fill={playing ? '#5073C3' : '#CFD8DC'}
          style={{ transition: 'all 350ms' }}
        />
        <path
          d="M21 7H15V9H21V7ZM17 20H19V14H17V20ZM25.03 13.39L26.45 11.97C26.02 11.46 25.55 10.98 25.04 10.56L23.62 11.98C22.07 10.74 20.12 10 18 10C13.03 10 9 14.03 9 19C9 23.97 13.02 28 18 28C22.98 28 27 23.97 27 19C27 16.88 26.26 14.93 25.03 13.39ZM18 26C14.13 26 11 22.87 11 19C11 15.13 14.13 12 18 12C21.87 12 25 15.13 25 19C25 22.87 21.87 26 18 26Z"
          fill={playing ? '#FFFFFF' : '#3D517B'}
          style={{ transition: 'all 350ms' }}
        />
      </svg>
    </SvgIcon>
  )
}

TimeRecordingPlayIcon.propTypes = {
  sx: PropTypes.object,
  playing: PropTypes.bool
}
